// config.js
import { parseEther } from 'ethers';

/* global BigInt */  // This tells ESLint that BigInt is defined globally

// Network Configuration
export const BSC_TESTNET = {
  chainId: '0x61', // 97 in hex
  chainName: 'BNB Chain Testnet',
  nativeCurrency: {
    name: 'Testnet BNB',
    symbol: 'tBNB',
    decimals: 18
  },
  rpcUrls: ['https://data-seed-prebsc-2-s3.bnbchain.org:8545'],
  blockExplorerUrls: ['https://testnet.bscscan.com']
};

// WebSocket URL for real-time events
export const WS_PROVIDER_URL = 'wss://bsc-testnet.drpc.org';

// CoinFlip contract address and settings
export const COINFLIP_CONTRACT_ADDRESS = '0xC8e5e9Fe15042640edC6C0E3d0CC211Bc4A1B7d5';
export const COINFLIP_MIN_BET_AMOUNT = parseEther('0.015');
export const MIN_BET_AMOUNT = parseEther('0.015');

// Keno contract address and settings
export const KENO_CONTRACT_ADDRESS = '0xfF991fb74Bb6EdCe8c137F045bC5765434A45224'; // Replace with actual Keno contract address
export const KENO_MIN_BET_AMOUNT = parseEther('0.015');

// Gas settings
export const PRIORITY_FEE_GWEI = 3; 